<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">게시판 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">자주묻는질문 관리</p>
          <ul class="depth">
            <li><router-link to="/noticemanagement" title="공지사항 관리">공지사항 관리</router-link></li>
            <li><router-link to="/faqmanagement" title="자주묻는질문 관리">자주묻는질문 관리</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">자주묻는질문 등록</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                자주묻는질문 등록 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 80px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">제목<span class="redDot">*</span></th>
                  <td>
                    <input type="text" title="제목 입력" v-model="title" />
                    <div class="error" v-if="!$v.title.required">필수입력란입니다.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">내용<span class="redDot">*</span></th>
                  <td>
                    <div id="ckeditorTA">
                      <ckeditor
                        :editor="editor"
                        v-model="cts"
                        @input="ctsInput"
                        :config="editorConfig"
                        @ready="onReady"
                      ></ckeditor>
                    </div>
                    <div class="error" v-if="cts == '' && ctsChk">필수 입력란입니다.</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <button class="btn border" @click="goBackConfirm">취소</button>
          <button class="btn blue" @click="insertBtn">저장</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import { required } from 'vuelidate/lib/validators';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
import { MyCustomUploadAdapterPlugin } from '../../../assets/js/UploadAdapter';

export default {
  name: 'ckeditorTA',
  data() {
    return {
      listData: [],
      curPageNum: 1,
      dataPerPage: 10,
      nodata: true,
      firstName: '파일명',

      fileName: '',
      cts: '',
      title: '',
      bbsCd: 'FAQ',
      eFiles: [],
      submitStatus: '',
      editor: ClassicEditor,

      test: [v => !!v || '필수 입력란입니다.'],
      ctsChk: false,

      editorConfig: {
        language: 'ko',
        enterMode: 2,
        shiftEnterMode: 3,
        extraPlugins: [MyCustomUploadAdapterPlugin],
        mediaEmbed: {
          previewsInData: true,
        },
      },
    }
  },

  components: {
    ckeditor : CKEditor.component,
  },

  validations: {
    title: {
      required,
    },
    cts: {
      required,
    },
  },

  methods: {
    onReady(editor){
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      );
    },

    ctsInput() {
      if (this.ctsChk) {
        return;
      }
      this.ctsChk = true;
    },

    async insertBtn() {
      if (this.$v.$invalid) {
        alert('필수입력란입니다');
        return;
      }

      let apiParams = new FormData();
      apiParams.append('title', this.title);
      apiParams.append('cts', this.cts);
      apiParams.append('bbsCd', 'FAQ');
      const res = await axios('post', '/api/admin/board/' + this.bbsCd + '/insertAction.json', apiParams);
      const message = res.data.message;
      alert(message);
      this.$router.push('faqmanagement');
    },

    goBack() {
      this.$router.go(-1);
      localStorage.clear();
    },

    goBackConfirm() {
      this.$confirm({
        message: `취소하시겠습니까?`,
        button: {
          no: '아니오',
          yes: '예',
        },
        callback: confirm => {
          if (confirm) {
            this.goBack();
          }
        },
      });
    },
  },
};
</script>
